import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackExportWishListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/wishList/trackExportWishList";

const useTrackExportWishList = (
    parameters: TrackExportWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.exportWishList, parameters, options);
};

export default useTrackExportWishList;
